// Mock data for Yetkin Dienstleistungen website

export const navigationLinks = [
  { id: 1, name: 'Über uns', path: '/about' },
  { id: 2, name: 'Dienstleistungen', path: '/services' },
  { id: 3, name: 'Nachricht', path: '/news' },
  { id: 4, name: 'Partner & Sponsoren', path: '/partners' },
  { id: 5, name: 'Karriere', path: '/careers' },
  { id: 6, name: 'Kontakt', path: '/contact' }
];

export const heroContent = {
  tagline: 'Exzellenz in Hospitality',
  headline: 'Zuverlässige Gastgewerbe',
  subheadline: 'Personal-Lösungen',
  description: 'Gastgewerbebetriebe mit qualifizierten Fachkräften stärken',
  ctaText: 'Personal jetzt anfordern',
  videoUrl: 'https://customer-assets.emergentagent.com/job_yetkin-luxury/artifacts/0f5vqssu_Yetkin%20main%20video.mp4'
};

export const services = [
  {
    id: 1,
    title: 'Housekeeping Services',
    subtitle: 'Makellose Sauberkeit',
    description: 'Verlassen Sie sich auf Profis. Wir bieten geschultes Reinigungspersonal und Supervisoren, die Sauberkeit zur Priorität machen. Schaffen Sie eine sichere Wohlfühl-Atmosphäre, die Ihre Gäste lieben werden.',
    image: 'https://customer-assets.emergentagent.com/job_yetkin-luxury/artifacts/cmais6nz_HSK.jpg',
    videoUrl: 'https://customer-assets.emergentagent.com/job_yetkin-luxury/artifacts/1sbx9sm4_Yetkin%20Housekeeping%20FHD-.mp4',
    icon: 'sparkles'
  },
  {
    id: 2,
    title: 'Front Office, Concierge und Bell Staff Services',
    subtitle: 'Erster Eindruck zählt',
    description: 'Unser Front Office-Team ist das Gesicht Ihres Hotels. Wir garantieren herzliche Begrüßungen, reibungslose Check-ins und mehrsprachigen Service. Für einen Empfang, der Ihren Gästen im Gedächtnis bleibt.',
    image: 'https://customer-assets.emergentagent.com/job_yetkin-luxury/artifacts/xm9l9h1w_FO.jpg',
    videoUrl: 'https://customer-assets.emergentagent.com/job_yetkin-luxury/artifacts/nw03zfni_Yetkin%20Front%20office%20FHD_1.mp4',
    icon: 'users'
  },
  {
    id: 3,
    title: 'Fensterreinigungsdienste',
    subtitle: 'Kristallklare Sicht',
    description: 'Ob Lobbyfassade oder Gästezimmer: Unser spezialisiertes Team sorgt für streifenfreien Glanz im Innen- und Außenbereich. Wir garantieren kristallklare Fenster und ein strahlendes Erscheinungsbild.',
    image: 'https://customer-assets.emergentagent.com/job_yetkin-luxury/artifacts/z76vhwok_Window.jpg',
    videoUrl: 'https://customer-assets.emergentagent.com/job_yetkin-luxury/artifacts/5sedr1h5_Yetkin%20Window%20cleaning%20FHD_1.mp4',
    icon: 'grid3x3'
  },
  {
    id: 4,
    title: 'Küchen-, Stewarding- und Bankett-Services',
    subtitle: 'Kulinarische Exzellenz',
    description: 'Von der Vorbereitung bis zum Servieren: Wir stellen erstklassige Teams für Küche, Stewarding und Bankett. Mit Fachwissen und Leidenschaft sorgen wir für ein nahtloses Speiseerlebnis und höchste Lebensmittelsicherheit in Ihrem Betrieb.',
    image: 'https://customer-assets.emergentagent.com/job_yetkin-luxury/artifacts/jnolp16v_kitchen.jpg',
    videoUrl: 'https://customer-assets.emergentagent.com/job_yetkin-luxury/artifacts/5fjmjfr3_Yetkin%20kitchen%20stuff%20FHD_1.mp4',
    icon: 'chefHat'
  }
];

export const benefits = [
  {
    id: 1,
    title: 'Professionelles Personal',
    description: 'Qualifizierte und erfahrene Fachkräfte',
    icon: 'award'
  },
  {
    id: 2,
    title: 'Zuverlässiger Service',
    description: 'Pünktlich und verlässlich rund um die Uhr',
    icon: 'clock'
  },
  {
    id: 3,
    title: 'Gäste Zufriedenheit',
    description: 'Höchste Standards für Ihre Gäste',
    icon: 'heart'
  },
  {
    id: 4,
    title: 'Flexible Lösungen',
    description: 'Angepasst an Ihre Bedürfnisse',
    icon: 'settings'
  }
];

export const sponsor = {
  name: 'Alba Berlin',
  description: 'Unterstützung des professionellen Basketballs in Berlin mit unserem Engagement für Exzellenz in Hospitality-Dienstleistungen.',
  logo: 'https://customer-assets.emergentagent.com/job_06972469-7cb0-4f7b-b9a7-af9efd6ba5bc/artifacts/6nm3v4qi_ALBA_Logo_RGB.png'
};

export const partners = [
  { id: 1, name: 'Revo Hospitality Group', logo: 'https://customer-assets.emergentagent.com/job_modern-yetkin-1/artifacts/rid6bj22_REVO.jpeg' },
  { id: 2, name: 'Louvre Hotels', logo: 'https://customer-assets.emergentagent.com/job_modern-yetkin-1/artifacts/qmpgw7cq_0Yi5mp69_400x400.jpg' },
  { id: 3, name: 'Motel One', logo: 'https://customer-assets.emergentagent.com/job_modern-yetkin-1/artifacts/1wb3r7ka_motel-one-logo-klein.webp' },
  { id: 4, name: 'H-Hotels', logo: 'https://customer-assets.emergentagent.com/job_modern-yetkin-1/artifacts/4vs2c4kn_h-hotels-logo.jpeg' },
  { id: 5, name: 'Titanic Hotels', logo: 'https://customer-assets.emergentagent.com/job_modern-yetkin-1/artifacts/bs0kcfuz_titanic-hotels.png' },
  { id: 6, name: 'Leonardo Hotels', logo: 'https://customer-assets.emergentagent.com/job_modern-yetkin-1/artifacts/karv48df_leonardo-hotels-logo.webp' },
  { id: 7, name: 'Ibis Hotels', logo: 'https://customer-assets.emergentagent.com/job_modern-yetkin-1/artifacts/apcd57oc_Logo_Ibis-Hotel_2012.png' }
];

export const aboutContent = {
  name: 'Cagdas Yetkin',
  role: 'Geschäftsführer',
  image: 'https://customer-assets.emergentagent.com/job_06972469-7cb0-4f7b-b9a7-af9efd6ba5bc/artifacts/0dy89oha_Cagdass.png',
  bio: [
    'Ausgebildet in der 5-Sterne-Hotellerie, erkannte ich schnell meine Leidenschaft für den Beruf des Hotel-Concierge. Nach meiner Ausbildung folgte ich dem klassischen Weg vom Pagen zum Concierge, bis ich mich schließlich selbstständig machte und seit 2018 mit meinem Team aus erfahrenen Hotel-Concierges mehrere Hotels in Berlin unterstütze.',
    'Geprägt von den Schwierigkeiten der Pandemie, formte sich in mir die Idee der Veränderung, und so fand ich einen Weg, das Geschäft zu erweitern. Seit 2021 unterstütze ich mehrere Hotels in Berlin und Brandenburg im Bereich Housekeeping.',
    'Für mich ist exzellenter Service genauso wichtig wie Sauberkeit und Hygiene im Unternehmen. Ich bin täglich persönlich im Einsatz, um Sie in diesen Bereichen zu unterstützen und stehe im Notfall fast rund um die Uhr zur Verfügung, um jederzeit reagieren zu können.'
  ]
};

export const contactInfo = {
  title: 'Kontaktaufnahme',
  subtitle: 'Haben Sie eine Frage oder möchten Sie mit uns zusammenarbeiten? Senden Sie uns eine Nachricht und wir melden uns bald bei Ihnen.',
  fields: [
    { name: 'firstName', label: 'Vorname', type: 'text', required: true },
    { name: 'lastName', label: 'Nachname', type: 'text', required: true },
    { name: 'email', label: 'E-Mail', type: 'email', required: true },
    { name: 'subject', label: 'Betreff', type: 'text', required: true },
    { name: 'message', label: 'Nachricht', type: 'textarea', required: true }
  ]
};

export const footerContent = {
  company: 'Yetkin Dienstleistungen',
  tagline: 'Exzellenz in Hospitality-Dienstleistungen',
  copyright: '© 2025 Yetkin Dienstleistungen. Alle Rechte vorbehalten.',
  socialLinks: [
    { name: 'LinkedIn', url: '#' },
    { name: 'Instagram', url: '#' },
    { name: 'Facebook', url: '#' }
  ]
};
